module.exports = __webpack_public_path__ + "img/gif-bot.15b374a8.png";